import { render, staticRenderFns } from "./CoverageFormula.vue?vue&type=template&id=71382d3b&scoped=true"
import script from "./CoverageFormula.vue?vue&type=script&lang=js"
export * from "./CoverageFormula.vue?vue&type=script&lang=js"
import style0 from "./CoverageFormula.vue?vue&type=style&index=0&id=71382d3b&prod&lang=css"
import style1 from "./CoverageFormula.vue?vue&type=style&index=1&id=71382d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71382d3b",
  null
  
)

export default component.exports